import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCocktail: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cocktail, drink"><path d="M3.73982 3C2.10761 3 1.36406 5.03703 2.61247 6.0885L11.2502 13.3636V20.5H7.75024C7.33603 20.5 7.00024 20.8358 7.00024 21.25C7.00024 21.6642 7.33603 22 7.75024 22H16.2502C16.6645 22 17.0002 21.6642 17.0002 21.25C17.0002 20.8358 16.6645 20.5 16.2502 20.5H12.7502V13.3636L21.3879 6.0885C22.6364 5.03703 21.8928 3 20.2606 3H3.73982Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCocktail;
